import axios from 'axios';

export function request(method: string, url: string, data: any, isLoader = true) {
    const reqObject = {
        method, url, data, isLoader
    };
    return axios(reqObject);
}

export function requestWithParam(method: string, url: string, data: any, params:any, isLoader = true) {
    const reqObject = {
        method, url, data, params, isLoader,
        paramsSerializer: {
            serialize: (rawParams: Record<string, any>) => {
                const searchParams = new URLSearchParams();
                Object.entries(rawParams || {}).forEach(([key, value]) => {
                    if (value === undefined || value === null || value === '') return;
                    if (Array.isArray(value)) {
                        value.forEach((item) => searchParams.append(key, String(item)));
                        return;
                    }
                    searchParams.append(key, String(value));
                });
                // Prevent spaces from being serialized as '+' in query strings.
                return searchParams.toString().replace(/\+/g, '%20');
            }
        }
    };
    return axios(reqObject);
}

export function upload(url: string, formData: FormData) {
    // Let the browser set multipart boundary — do not force Content-Type.
    return axios.post(url, formData);
}

export function downloadFile(url: string) {
    return axios.get(url, {
        responseType: 'blob',
    });
}
